var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArkcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7366 0.799875C14.1395 0.797147 14.5389 0.874268 14.9118 1.02678C15.2847 1.1793 15.6236 1.40418 15.9091 1.68844L15.4272 2.17237L15.911 1.69033C16.1954 1.97572 16.4204 2.31465 16.5729 2.68752C16.7255 3.0604 16.8027 3.45982 16.8 3.86269C16.7972 4.26557 16.7147 4.66391 16.5571 5.03468C16.4 5.40415 16.1715 5.73894 15.8847 6.01984L15.623 6.28157L15.6176 6.28702L15.6121 6.29241L6.4705 15.434C6.46714 15.4376 6.46373 15.441 6.46028 15.4445C6.45333 15.4515 6.44627 15.4582 6.4391 15.4648C6.35569 15.5425 6.25405 15.5982 6.14339 15.6265L1.6524 16.7784C1.41862 16.8383 1.17055 16.7705 0.999874 16.5998C0.829202 16.4292 0.761279 16.1811 0.821208 15.9473L1.97241 11.4563C2.0028 11.3378 2.0645 11.2295 2.15104 11.143L11.5792 1.71481C11.8602 1.4281 12.1951 1.19968 12.5646 1.04267C12.9354 0.885123 13.3337 0.802602 13.7366 0.799875ZM5.97642 13.9965L14.1689 5.8041L11.7952 3.43045L3.60067 11.6249L5.97642 13.9965ZM2.99855 12.9538L4.64776 14.6001L2.43078 15.1687L2.99855 12.9538ZM15.3001 4.50033C15.2516 4.61435 15.1908 4.72239 15.1189 4.82258L12.7768 2.48049C12.877 2.40879 12.9849 2.34812 13.0987 2.29974C13.3035 2.21275 13.5234 2.16718 13.7458 2.16568C13.9683 2.16417 14.1888 2.20675 14.3947 2.29096C14.6002 2.375 14.787 2.49883 14.9444 2.65533C15.1009 2.81266 15.2248 2.9994 15.3089 3.20481C15.3931 3.41062 15.4357 3.63108 15.4342 3.85344C15.4327 4.07581 15.3871 4.29568 15.3001 4.50033Z",
    fill: "#2F2F2F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkcEdit);
export default __webpack_public_path__ + "static/media/arkc-edit.4b0cccd93ada3f5a67044ad1e9a1384a.svg";
export { ForwardRef as ReactComponent };